import utilityService from '../../../services/utility.service';

const getIconSize = (noOfItem) => {
  const remainingHeight = window.innerHeight - utilityService.getHeaderHeight();
  return remainingHeight / noOfItem;
};
export { getIconSize };
